import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { config } from '@/config/config';
import { AuthLayout } from '@/modules/layouts/components/authLayout/AuthLayout';
import { DocumentMetadata } from '@/modules/layouts/components/DocumentMetadata';

/**
 * Where the API's `/oauth/authorize` sends a connecting MCP client's user
 * without a valid session. `ProtectedRoute` signs them in, or refreshes an
 * expired access cookie, then this page sends the same query back to the API,
 * which continues to `/oauth/consent`. The target is always the API's
 * authorize URL, so the query can't redirect anywhere else.
 */
export const OAuthAuthorize = () => {
  const { search } = useLocation();

  useEffect(() => {
    const authorizeUrl = new URL('oauth/authorize', config.app.apiBaseUrl);
    authorizeUrl.search = search;
    window.location.replace(authorizeUrl);
  }, [search]);

  return (
    <AuthLayout
      heading="Connecting to Finlay"
      subheading="Taking you to the next step."
    >
      <DocumentMetadata title="Connecting to Finlay" />
    </AuthLayout>
  );
};
